import React, {useEffect, useState} from "react";
import initMap from "./initMap";

interface IMapProps {
    callback?: Function,
    center: [number, number]
}

export function Map(props: IMapProps) {
    // @ts-ignore
    const [map, setMap] = useState<ymaps.Map>()

    useEffect(() => {
        initMap({
            center: props.center,
            zoom: 10,
            // @ts-ignore
            callback: (map: ymaps.Map) => {
                setMap(map);
                props.callback?.(map);
            },
        });
        return () => {
            map?.geoObjects.removeAll();
            map?.destroy();
        };
    }, []);

    return <div style={{backgroundColor: '#cfe8fc', width:"100%", height: '100%'}} id='default_map_id'/>;
}
//
// export class BaseMap<P extends IBaseMapProps> extends React.Component<P> {
//     // @ts-ignore
//     map: ymaps.Map;
//     defaultId: string = 'default_map_id';
//     zones: Zones;
//     // @ts-ignore
//     areas: ymaps.GeoObjectCollection;
//
//     get id() {
//         return this.props.options?.id || this.defaultId;
//     }
//
//
//     // @ts-ignore
//     customInit(map: ymaps.Map) {
//         this.map = map;
//         if (!this.props.options.hideControls) {
//             // buildZoomControl(this.map);
//             // buildBoundControl(this.map);
//         }
//         // this.areas = new ymaps.GeoObjectCollection();
//         // this.map.geoObjects.add(this.areas);
//
//         this.props.disableDrug && this.map.behaviors.disable('drag');
//     }
//
//     componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<{}>, snapshot?: any) {
//
//     }
//
//     drawAreas() {
//         this.areas?.removeAll();
//
//         // let extractArea = this.props.areas?.find(area => area.area_tags.includes('extract'));
//         //
//         // createGlobalAreas(
//         //     {
//         //         inner: extractArea,
//         //         collection: this.areas
//         //     });
//         //
//         // createOtherAreas({
//         //     areas: this.props.areas,
//         //     collection: this.areas,
//         //     extractArea
//         // });
//     }
//
//     // showAreas(filterItems: IShowItemsFilter) {
//     //     showArea({
//     //         ...filterItems,
//     //         collection: this.areas
//     //     });
//     // }
//
//     componentDidMount() {
//         initMap({
//             ...Object.assign({}, this.props.options, {id: this.id}),
//             // @ts-ignore
//             callback: (map: ymaps.Map) => {
//                 this.customInit(map);
//             },
//         });
//     }
//
//     componentWillUnmount() {
//         this.map?.destroy();
//     }
//
//     render() {
//         return <div style={{backgroundColor: '#cfe8fc', height: '100%', width: '100%'}} id={this.id}/>;
//     }
// }